import React, { useEffect, useState } from "react";
import { FaHandshake } from "react-icons/fa";
import MyPage from "../components/MyPage";

function Sahakaranam() {
  const [data, setData] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    fetch("/api/sahakaranam.json")
      .then(res => res.json())
      .then(d => setData(d));
  }, []);

  if (!data) return null;

  return (
    <>
     {/* ✅ SEO */}
     <MyPage
        title="Sahakarnam | Thrissur Jilla Pravasi Kootayma"
        description="Thrissur Pravasi families united through community engagement and social welfare."
        keywords="Thrissur Pravasi, Community Engagement, Pravasi Activities"
      />
      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner banner-animate">
        <div className="inner-overlay"></div>
        <div className="inner-content">
          <h1>{data.banner.title}</h1>
        </div>
        <div className="breadcrumb">
          {data.banner.breadcrumb}
        </div>
      </section>

      {/* ===== SAHAKARANAM ===== */}
      <section className="saha-section">
        <div className="saha-wrapper">

          <div className="saha-content">
            {data.intro.map((p, i) => <p key={i}>{p}</p>)}

            <h2>
              <FaHandshake /> {data.section.title} <span></span>
            </h2>

            {data.section.description.map((p, i) => (
              <p key={i}>{p}</p>
            ))}

            <a href={data.section.button.link} className="saha-btn">
              {data.section.button.text}
            </a>

            {/* GALLERY */}
            {/*<div className="saha-gallery">
              {data.gallery.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  onClick={() => setActiveImage(img)}
                />
              ))}
            </div>*/}
          </div>

          <div className="saha-image">
            <img src={data.sideImage} alt="Sahakaranam" />
          </div>
        </div>
      </section>

      {/* ===== WHY SECTION ===== */}
      <section className="why-section">
        <div className="why-wrapper">

          <div className="why-left">
            <h2>
              <FaHandshake /> {data.why.title} <span></span>
            </h2>

            <p className="why-desc">{data.why.description}</p>

            <div className="why-images">
              {data.why.images.map((img, i) => (
                <img key={i} src={img} alt="" />
              ))}
            </div>
          </div>

          <div className="why-cards">
            {data.why.cards.map((c, i) => (
              <div className="why-card" key={i}>
                <span>{c.no}</span>
                <h4>{c.title}</h4>
                <p>{c.text}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ===== IMAGE MODAL ===== */}
      {activeImage && (
        <div className="image-modal" onClick={() => setActiveImage(null)}>
          <span className="close-btn">×</span>
          <img src={activeImage} alt="" />
        </div>
      )}

      {/* ================= CSS ================= */}
      <style>{`
/* ===== COMMON ===== */
.inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}

h2 {
  font-family: "Merriweather", serif;
  font-size: 34px;
  display: flex;
  align-items: center;
  gap: 10px;
}

h2 span {
  width: 50px;
  height: 2px;
  background: #000;
}

/* ===== SAHAKARANAM ===== */
.saha-section {
  padding: 100px 80px;
  background: #fff;
}

.saha-wrapper {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 70px;
  align-items: center;
}

.saha-content p {
  font-size: 16px;
  line-height: 1.8;
  margin: 20px 0;
}

.saha-btn {
  display: inline-block;
  margin-top: 20px;
  background: #a8cf45;
  color: #000;
  padding: 14px 26px;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
}

.saha-image img {
  width: 100%;
  border-radius: 18px;
  box-shadow: 0 15px 30px rgba(0,0,0,0.15);
}

/* ===== WHY SECTION ===== */
.why-section {
  padding: 100px 80px;
  background: #f9fbf6;
}

.why-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 70px;
}

.why-desc {
  margin: 18px 0 35px;
  line-height: 1.7;
}

.why-images {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.why-images img {
  width: 100%;
  border-radius: 14px;
  object-fit: cover;
}

.why-cards {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 25px;
}

.why-card {
  background: #fff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(0,0,0,0.08);
}

.why-card span {
  font-weight: 700;
  color: #a8cf45;
}

.why-card h4 {
  margin: 12px 0;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 992px) {
  .saha-wrapper,
  .why-wrapper {
    grid-template-columns: 1fr;
  }

  .why-cards {
    grid-template-columns: 2fr;
  }
}

@media (max-width: 768px) {
  .saha-section,
  .why-section {
    padding: 60px 20px;
     overflow-x: hidden; 
  }

  h2 {
    font-size: 26px;
  }
}
  /* ================= INNER BANNER RESPONSIVE ================= */
@media (max-width: 768px) {
  .inner-content h1 {
    font-size: 36px;
  }

  .breadcrumb {
    left: 16px;
    padding: 8px 12px;
    font-size: 12px;
  }
}
  /* ================= INNER BANNER ANIMATION ================= */

.banner-animate .inner-content {
  opacity: 0;
  transform: translateY(-40px);
  animation: bannerFadeDown 0.9s ease forwards;
}

.banner-animate .breadcrumb {
  opacity: 0;
  transform: translateY(40px);
  animation: bannerFadeUp 0.9s ease forwards;
  animation-delay: 0.2s;
}

@keyframes bannerFadeDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bannerFadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
  /* ===== SAHAKARANAM GALLERY ===== */
.saha-gallery {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 🔥 3 per row */
  gap: 20px;
}

.saha-gallery img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.12);
  transition: transform 0.3s ease;
}

.saha-gallery img:hover {
  transform: translateY(-6px);
}
@media (max-width: 992px) {
  .saha-gallery {
    grid-template-columns: repeat(2, 1fr); /* tablet */
  }
}

@media (max-width: 576px) {
  .saha-gallery {
    grid-template-columns: 1fr; /* mobile */
  }

}
  @media (max-width: 576px) {
  .saha-gallery img {
    height: auto;              /* ✅ NO CUT */
    aspect-ratio: 4 / 3;       /* ✅ neat ratio */
    object-fit: cover;
  }
}

  /* ===== IMAGE MODAL / LIGHTBOX ===== */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.image-modal img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
}

.close-btn {
  position: absolute;
  top: 25px;
  right: 30px;
  font-size: 40px;
  color: #fff;
  cursor: pointer;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
  /* ===== WHY SECTION LOAD ANIMATION ===== */

/* Initial hidden state */
.why-left,
.why-cards {
  opacity: 0;
}

/* Left side: slide from left */
.why-left {
  transform: translateX(-60px);
  animation: slideFromLeft 0.9s ease forwards;
}

/* Right side: slide from right */
.why-cards {
  transform: translateX(60px);
  animation: slideFromRight 0.9s ease forwards;
  animation-delay: 0.2s; /* thodu natural lage */
}

.saha-content,
.saha-image,
.saha-gallery,
.why-left,
.why-cards {
  opacity: 0;
}

/* LEFT → RIGHT */
.saha-content,
.why-left {
  transform: translateX(-70px);
  animation: slideLeft 1s ease forwards;
  animation-delay: 0.3s;
}

/* RIGHT → LEFT */
.saha-image,
.why-cards {
  transform: translateX(70px);
  animation: slideRight 1s ease forwards;
  animation-delay: 0.5s;
}

/* BOTTOM → UP */
.saha-gallery {
  transform: translateY(60px);
  animation: slideUp 1s ease forwards;
  animation-delay: 0.7s;
}

/* KEYFRAMES */
@keyframes slideLeft {
  to { opacity: 1; transform: translateX(0); }
}
@keyframes slideRight {
  to { opacity: 1; transform: translateX(0); }
}
@keyframes slideUp {
  to { opacity: 1; transform: translateY(0); }
}


      `}</style>
    </>
  );
}

export default Sahakaranam;
